import { render, staticRenderFns } from "./BaseInputCheckbox.vue?vue&type=template&id=1c3b8742&scoped=true&"
import script from "./BaseInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseInputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputCheckbox.vue?vue&type=style&index=0&id=1c3b8742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b8742",
  null
  
)

export default component.exports